"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function QuienesSomosResumen() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="bg-background py-16 px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className={`space-y-6 transition-all duration-[var(--duration-slow)] ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h2 className="font-display text-4xl font-bold text-foreground lg:text-5xl">
              Quiénes somos
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Vokse Global Consulting es una consultora B2B especializada en gestión comercial, marketing, e‑commerce y branding. Operamos como departamento externalizado, integrando nuestros servicios directamente con los equipos de nuestros clientes.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Nuestro expertise se centra en canales de ferretería, suministro industrial y materiales de construcción, donde gestionamos redes multicartera de representantes y equipos propios o mixtos con enfoque estratégico y orientado a resultados.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Apoyamos a empresas a optimizar sus ventas, fortalecer su presencia digital y alcanzar un crecimiento sostenible en mercados B2B competitivos.
            </p>
          </div>

          {}
          <div ref={rightRef} className={`transition-all duration-[var(--duration-slow)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <Card className="overflow-hidden shadow-medium hover:shadow-strong hover:-translate-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508450/img/vokse_consulting_team_professionals.png" alt="Equipo de Vokse Global Consulting" className="w-full h-auto object-cover" />
            </Card>
          </div>
        </div>
      </div>
    </section>;
}